<header>
  <nav
    class="navbar navbar-expand-md navbar-dark bg-primary nav-fixated-z-index"
  >
    <div class="container-fluid">
      <a href="#">
        <img
        src="assets/img/logo_invitalia_bianco.svg"
        class="d-block img-fluid logo ms-4 me-4"
        alt="Timesheet Mensile"
        loading="lazy"
        />
      </a>
      <a class="fw-semibold fs-4 text-white text-decoration-none" href="#">Timesheet Mensile</a>
      <!-- <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button> -->
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <div class="w-100 d-flex align-items-center justify-content-end">
          <div class="d-block">
            <div class="d-flex align-items-center">
              <div class="user-info">
                <span class="text-white text-center mt-1 me-2 fw-semibold" style="font-size: 14px;">
                  {{ utente.cognome | uppercase }} {{ utente.nome | uppercase }}
                </span>
                <!-- <span class="text-white text-end mt-1 me-2 fw-semibold" style="font-size: 12px;">
                  {{ utente.societa }}
                </span> -->
              </div>
              <div
                class="d-flex align-items-center justify-content-center text-white rounded-circle fw-semibold text-uppercase bg-slate-400">
                {{ utente.cognome?.replaceAll(' ','')?.replaceAll('\n', '')?.charAt(0)}}{{utente.nome?.replaceAll('
                ','')?.replaceAll('\n', '')?.charAt(0) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>
